import { render } from "./Separador.vue?vue&type=template&id=ec13701a"
const script = {}
script.render = render

export default script